var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return (_vm.$options.m.shouldShowStatus(_vm.props))?_c('span',{staticClass:"kiwi-awaystatusindicator",class:( _obj = {
        'kiwi-awaystatusindicator--away': _vm.props.user && _vm.props.user.isAway(),
        'kiwi-awaystatusindicator--self': _vm.$options.m.isUserSelf(_vm.props)
    }, _obj[_vm.data.staticClass] = true, _obj ),on:{"click":function($event){return _vm.$options.m.toggleSelfAway(_vm.props)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }